import { Action } from '@ngrx/store';
import { type } from '../../../util';

import { Form, Answer } from '../../../shared/models/form.model';
import { AnswersByPatient } from './reason-form.reducer';

export const actionTypes = {
  SET_FORM: type('[Reason form] Set the reason form'),
  SET_CURRENT_QUESTION: type('[Reason form] Set the current question'),
  SET_ANSWER: type('[Reason form] Set an answer'),
  RESET_ANSWERS: type('[Reason form] Reset all the answers'),
  RESET_FORM: type('[Reason form] Reset the form'),
};

export class SetForm implements Action {
  type = actionTypes.SET_FORM;

  constructor(public payload: Form) {}
}

export class SetCurrentQuestion implements Action {
  type = actionTypes.SET_CURRENT_QUESTION;

  constructor(public payload: number) {}
}

export class SetAnswer implements Action {
  type = actionTypes.SET_ANSWER;

  constructor(public payload: AnswersByPatient) { }
}

export class ResetAnswers implements Action {
  type = actionTypes.RESET_ANSWERS;
}

export class ResetForm implements Action {
  type = actionTypes.RESET_FORM;
}

export type Actions
  = SetForm
  | SetCurrentQuestion
  | SetAnswer
  | ResetAnswers
  | ResetForm;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form.actions.ts